import {IEnumListEntry} from "../definitions";

export const ONMAP_TAGS = {
  BOUGHT:"BOUGHT",
  CONSTRUCTED:"CONSTRUCTED",
  UPGRADED:"UPGRADED",
  REMOVED:"REMOVED",
  EXISTS:"EXISTS",
  LOAFING:"LOAFING",
  WORKING:"WORKING",
  ITEM_PRODUCED:"ITEM_PRODUCED",
  SECTOR_UNLOCKED:"SECTOR_UNLOCKED",
  STARVING:"STARVING",
  FULL:"FULL",
  TALKED_TO:"TALKED_TO",
  QUEST_COMPLETED:"QUEST_COMPLETED",
  INV_QUEST_COMPLETED:"INV_QUEST_COMPLETED",
  DAILY_QUEST_COMPLETED:"DAILY_QUEST_COMPLETED",
  MARKET_ORDER_COMPLETED:"MARKET_ORDER_COMPLETED",
  AVAILABLE:"AVAILABLE",
  LEVEL_UP:"LEVEL_UP",
  RUBIES_SPENT:"RUBIES_SPENT",
  PLAYED_WITH:"PLAYED_WITH",
  DIRIGIBLE_ARRIVED:"DIRIGIBLE_ARRIVED",
  DIRIGIBLE_EXPIRED:"DIRIGIBLE_EXPIRED",


};

export const ONMAP_TAGS_LIST:IEnumListEntry[] = Object.keys(ONMAP_TAGS).map(key => {
  return <IEnumListEntry>{ id: ONMAP_TAGS[key], label: key };
});



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-onmap-tags.ts